<template>
  <section :class="$style.pressContainer">
    <div :class="$style.subcontainer">
      <Wrapper :class="$style.inner">
        <PressSidebar
          :class="$style.sidebar"
          :logo="sidebar.logo"
          :title="sidebar.title"
          :date="sidebar.date"
        />
        <div :class="$style.article">
          <PImage :image-object="article.image" :class="$style.image" />
          <RichText :text-params="article.intro" :class="$style.intro" />
          <RichText :text-params="article.summary" :class="$style.summary" />
          <PLink
            :link-object="article.ctaLink"
            is-highlight
            :class="$style.link"
          >
            {{ article.ctaText }}
          </PLink>
        </div>
      </Wrapper>
    </div>
  </section>
</template>

<script>
import RichText from '~/components/RichText'
import PImage from '~/components/PImage'
import PLink from '~/components/PLink'

import PressSidebar from '../PressSidebar'

export default {
  name: 'PressContent',

  components: {
    PressSidebar,
    RichText,
    PImage,
    PLink,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    article() {
      return this.content.article
    },

    sidebar() {
      return this.content.sidebar
    },
  },
}
</script>

<style lang="scss" module>
.subcontainer {
  padding: 0 24px;
}

.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0 160px;

  @include above(medium) {
    flex-direction: row;
    align-items: inherit;
    justify-content: space-between;
  }
}

.sidebar {
  flex-grow: 1;
  min-width: 0;
  max-width: 620px;

  @include above(medium) {
    min-width: 300px;
    max-width: 475px;
    margin-right: 80px;
  }
}

.article {
  flex-grow: 1;
  max-width: 620px;
  margin-top: 80px;

  @include above(medium) {
    margin-top: 0;
  }
}

.image {
  width: 100%;
  height: 330px;
  border-radius: 8px;
  object-fit: cover;
}

.intro {
  margin-top: 80px;
  * {
    @include typo-headline;
    color: $gray-1000;
  }
}

.summary {
  margin-top: 24px;

  color: $gray-700;
}

.link {
  margin-top: 24px;
}
</style>
